import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { isCompany360Active } from '../../../graph-ql/queries';

@Injectable()
export class Company360Service {

  constructor(public apollo: Apollo) {
  }

  isCompany360Active$(): Observable<boolean> {
    return this.apollo.query<boolean>({
      query: isCompany360Active,
    }).pipe(map(result => result.data['isCompany360Active']));
  }
}
